import Dispatcher from 'live/lib/dispatcher'
import ActionsListFactory from 'live/components/lists/lib/actions'
import {
    GET_ALL_COLLECTIONS_STATS,
    GET_ALL_COLLECTIONS_MAPPING_NAMES,
    DELETE_COLLECTION,
    CREATE_INDEX,
    DELETE_INDEX,
    FILTER_COLLECTIONS,
    FILTER_DEFAULT_INDEXES
} from './constants'

const Factory = namespace => {
    const ActionsList = ActionsListFactory(namespace)
    const Actions = {
        getAllCollectionsStats: function (qualifier) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: GET_ALL_COLLECTIONS_STATS,
                params: { qualifier }
            })
        },

        getAllCollectionsMappingNames: function (qualifier) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: GET_ALL_COLLECTIONS_MAPPING_NAMES,
                params: { qualifier }
            })
        },

        deleteCollection: function (qualifier, name) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: DELETE_COLLECTION,
                params: { qualifier, name }
            })
        },

        createIndex: function (qualifier, collections, index) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: CREATE_INDEX,
                params: { qualifier, collections, index }
            })
        },

        deleteIndex: function (qualifier, index) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: DELETE_INDEX,
                params: { qualifier, index }
            })
        },

        filterCollections: function (qualifier, filter) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: FILTER_COLLECTIONS,
                params: { qualifier, filter }
            })
        },

        filterDefaultIndexes: function (qualifier) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: FILTER_DEFAULT_INDEXES,
                params: { qualifier }
            })
        }
    }

    return { ...Actions, ...ActionsList }
}

export default Factory
